const faqItems = [
  {
    q: '星球漫画是否完全免费？需要付费吗？',
    a: '星球漫画所有内容完全免费，无需任何付费或VIP订阅即可畅读全部漫画。我们坚持免费漫画全集阅读的理念，让每一位漫画爱好者都能零门槛享受免费在线漫画的乐趣。',
  },
  {
    q: '需要注册账号才能阅读免费漫画吗？',
    a: '不需要。星球漫画支持免登录阅读，打开网站即可直接浏览和阅读所有免费漫画内容，无需注册账号，真正做到打开即看。',
  },
  {
    q: '漫画的更新频率怎么样？',
    a: '星球漫画每日更新超过三百部作品，热门连载漫画保持与官方同步的更新节奏。我们会第一时间收录最新话，确保你能及时追更喜欢的免费漫画。',
  },
  {
    q: '支持哪些设备阅读？手机能看吗？',
    a: '星球漫画全面适配桌面端、平板和手机端，支持下拉式阅读模式，在手机上也能获得流畅的免费在线漫画阅读体验，随时随地想看就看。',
  },
  {
    q: '如何快速找到想看的免费漫画？',
    a: '你可以通过首页的热门专题、人气排行、话题标签等多种方式浏览漫画，也可以使用分类筛选功能按题材查找。我们推荐从精选推荐板块开始探索好看的免费漫画。',
  },
  {
    q: '遇到页面加载慢或显示异常怎么办？',
    a: '建议先检查网络连接，尝试刷新页面。如果问题持续存在，可以清除浏览器缓存后重试。你也可以通过联系我们板块向我们反馈具体问题，我们会尽快优化处理。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          常见问题
        </h2>
        <p className="text-foreground-600 text-sm text-center mb-10 md:mb-14 max-w-xl mx-auto">
          关于免费漫画阅读的常见疑问，这里都有答案
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 max-w-[1000px] mx-auto">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-5 md:p-6 hover:bg-background-200/70 transition-colors"
            >
              <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2 flex items-start gap-3">
                <span className="text-primary-500 shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {item.q}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed pl-7">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}